import { baseApiClient as api } from "../baseService";
export const addTagTypes = ["contacts"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      recipientDirectorySearch: build.query<
        RecipientDirectorySearchApiResponse,
        RecipientDirectorySearchApiArg
      >({
        query: (queryArg) => ({
          url: `/api/recipient-directory/`,
          params: {
            limit: queryArg.limit,
            q: queryArg.q,
          },
        }),
        providesTags: ["contacts"],
      }),
      recipientDirectoryContacts: build.query<
        RecipientDirectoryContactsApiResponse,
        RecipientDirectoryContactsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/recipient-directory/contacts/`,
          params: {
            entity_id: queryArg.entityId,
            entity_type: queryArg.entityType,
          },
        }),
        providesTags: ["contacts"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type RecipientDirectorySearchApiResponse =
  /** status 200  */ RecipientSearchResponse[];
export type RecipientDirectorySearchApiArg = {
  /** Maximum results per entity type (default: 50) */
  limit?: number;
  /** Search query for recipient name or aliases */
  q: string;
};
export type RecipientDirectoryContactsApiResponse =
  /** status 200  */ RecipientContactsResponse;
export type RecipientDirectoryContactsApiArg = {
  /** Entity UUID. Note: for entity_type=medical_provider, this is the MedicalProvider (matter-scoped) UUID stored on correspondence packages. */
  entityId: string;
  /** Entity type: insurance_carrier, medical_provider, or police_department */
  entityType: "insurance_carrier" | "medical_provider" | "police_department";
};
export type ContactCardType =
  | "medical_provider"
  | "police_department"
  | "insurance_carrier"
  | "party"
  | "custom";
export type RecipientSearchResult = {
  id: string;
  name: string;
  entity_type: ContactCardType;
  subtitle?: string | null;
};
export type RecipientSearchGroup = {
  entity_type: ContactCardType;
  label: string;
  items: RecipientSearchResult[];
};
export type RecipientSearchResponse = {
  /** All results across entity types */
  results: RecipientSearchResult[];
  /** Results grouped by entity type with labels */
  grouped_results: RecipientSearchGroup[];
};
export type DestinationAddress = {
  address_line1: string;
  address_line2?: string | null;
  city: string;
  state: string;
  zip_code: string;
  country?: string;
};
export type RecipientContactSource = {
  entity_type: ContactCardType;
  entity_id: string;
  entity_name: string;
  source_label?: string | null;
};
export type RecipientContactHandle = {
  /** Composite ID for the contact point */
  id: string;
  /** Database ID of the ContactHandle model */
  handle_id: string;
  display_name: string;
  label?: string | null;
  fax_number?: string | null;
  email?: string | null;
  address?: DestinationAddress;
  supported_channels: ("fax" | "mailed_letter" | "mailed_cheque" | "email")[];
  handle_type: string;
  source: RecipientContactSource;
};
export type RecipientContactsResponse = {
  entity_type: ContactCardType;
  entity_id: string;
  entity_name: string;
  contacts: RecipientContactHandle[];
};
export const {
  useRecipientDirectorySearchQuery,
  useRecipientDirectoryContactsQuery,
} = injectedRtkApi;
